module.exports = __webpack_public_path__ + "static/media/plus.084562f1.svg";